import styled, { css } from 'styled-components';

export const TotalCmp = styled.div`
  margin: 0 30px 0 0;
  font-size: 13px;
  font-weight: bold;
  color: #1c1c1c;
  display: flex;
  align-items: center;
  span {
    display: block;
    font-size: 15px;
  }
  ${(props) =>
    (props.theme === 'dark' || props.theme.theme === 'dark') &&
    css`
      color: #fff;
    `}
`;

export const RefreshBtn = styled.button`
  margin-left: 10px;
  width: 28px;
  height: 28px;
  border: 0;
  background: none;
  border-radius: 50%;
  cursor: pointer;
  img {
    transition: all ease-in 0.2s;
    height: 28px;
    width: auto;
  }
  &:hover {
    img {
      transform: rotate(30deg);
    }
  }
  &.loading {
    opacity: 1;
    position: relative;
  }
  &.loading:after {
    content: '';
    position: absolute;
    left: 0px;
    top: 0px;
    right: 0px;
    bottom: 0px;
    /* z-index: 999; */
    border-radius: 50%;
    background: rgba(255, 255, 255, 1) url(/images/loader.svg) no-repeat 50%;
  }
`;
